import { render, staticRenderFns } from "./subTab2.vue?vue&type=template&id=60533bcb&scoped=true"
import script from "./subTab2.vue?vue&type=script&lang=js"
export * from "./subTab2.vue?vue&type=script&lang=js"
import style0 from "./subTab2.vue?vue&type=style&index=0&id=60533bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60533bcb",
  null
  
)

export default component.exports